import {
  getNodeList,
  isNumberNode,
  isValueNode,
  Node,
  Plugin,
  updateErrors,
  ValueNode,
} from '@sagold/react-json-editor';

import {
  calculateSum,
  CustomNode,
  getCustomNode,
  getNodeFromJsonPath,
  getRelativePath,
  isArrayNode,
  isChangeEvent,
} from './pluginHelper';

function sumTotal(rootNode: Node, sumNode: CustomNode) {
  const summands = sumNode.schema.summandsExtended as string[];

  const pathsToLookUp = summands.map((pointer) =>
    getRelativePath(sumNode.pointer, pointer)
  );
  const sum = calculateSum(pathsToLookUp, rootNode, sumNode);

  if (sumNode.value !== sum) {
    sumNode.value = sum;
  }
}

function validateAgainst(rootNode: Node, validateAgainstNode: CustomNode) {
  const validateProperty = validateAgainstNode.schema[
    'validateAgainst'
  ] as string;
  if (typeof validateProperty !== 'string') {
    return;
  }

  const validateNode = getNodeFromJsonPath(
    validateAgainstNode.pointer,
    validateProperty,
    rootNode
  );
  if (validateNode == null) {
    return;
  }

  if (isNumberNode(validateNode)) {
    validateAgainstNode.schema.maximum = validateNode.value;
    validateAgainstNode.schema.minimum = validateNode.value;
  }
}

/**
 * This plugin directly modifies the node value to work-around the batched updates performed by react-json-editor.
 * It is similar to existing sum-plugin just differs in how the node is updated and additionally validates the node.
 */
export const SumExtendedPlugin: Plugin = (he) => {
  return {
    id: 'sum-extended-plugin',
    onEvent(root, event) {
      if (!isChangeEvent(event)) {
        return undefined;
      }
      for (const syncNode of getCustomNode(root, 'syncIfOneRow', true)) {
        for (const n of getNodeList(syncNode)) {
          if (typeof n.schema.options?.syncWith === 'string') {
            const sourceNode = getNodeFromJsonPath(
              n.pointer,
              n.schema.options?.syncWith,
              root
            ) as ValueNode;
            if (!isValueNode(n) || !isValueNode(sourceNode)) {
              continue;
            }
            if (!isArrayNode(syncNode) || syncNode.children.length === 1) {
              n.options.readOnly = true;
              if (n.value !== sourceNode.value) {
                n.value = sourceNode.value;
              }
            } else {
              n.options.readOnly = false;
            }
          }
        }
      }
      for (const addValue of getCustomNode(root, 'summandsExtended')) {
        sumTotal(root, addValue);
      }
      for (const sum of getCustomNode(root, 'validateAgainst')) {
        validateAgainst(root, sum);
        updateErrors(he.draft, sum);
      }
      return [root, []];
    },
  };
};
